export const COUNTRIES_STATE = 'COUNTRIES';